interface BuildPaymentReturnUrlOptions {
  readonly redirectUrl?: string;
  readonly currentUrl: string;
  readonly isEmbedded: boolean;
  readonly returnParams: URLSearchParams;
}

function parseRedirectUrl(redirectUrl?: string): URL | null {
  if (!redirectUrl) return null;

  try {
    const url = new URL(redirectUrl);
    return url.protocol === "https:" ? url : null;
  } catch {
    return null;
  }
}

export function buildPaymentReturnUrl({
  redirectUrl,
  currentUrl,
  isEmbedded,
  returnParams,
}: BuildPaymentReturnUrlOptions): string {
  const configuredUrl = parseRedirectUrl(redirectUrl);
  if (configuredUrl) {
    for (const [key, value] of returnParams) {
      configuredUrl.searchParams.set(key, value);
    }
    return configuredUrl.toString();
  }

  const currentLocation = new URL(currentUrl);
  return isEmbedded
    ? `${currentLocation.origin}${currentLocation.pathname}?${returnParams.toString()}`
    : `${currentLocation.origin}/confirm/?${returnParams.toString()}`;
}
